/**
 * Pages
 */
export const SET_PROPERTY_CONTENT = "SET_PROPERTY_CONTENT";
export const PAGES_RECEIVED = "PAGES_RECEIVED";
export const SET_CONTENT = "SET_CONTENT";
export const SET_PAGE = "SET_PAGE";
